document.addEventListener("DOMContentLoaded", function () {

  // Welcome slider
  var welcome_slider = document.querySelector('.welcome-slider__slides');
  if ( welcome_slider ) {
    var welcomeCells = welcome_slider.children.length;
    var welcomeHasMultiple = welcomeCells > 1;
    var welcomeFlkty = new Flickity(welcome_slider, {
      cellAlign: 'left',
      contain: true,
      wrapAround: welcomeHasMultiple,
      draggable: welcomeHasMultiple,
      prevNextButtons: false,
      pageDots: welcomeHasMultiple,
      autoPlay: welcomeHasMultiple ? 4000 : false,
      pauseAutoPlayOnHover: true,
      imagesLoaded: true
    });
    var wrapper = document.querySelector('.welcome-slider');
    var prevArrow = wrapper.querySelector('.custom-arrow.prev');
    var nextArrow = wrapper.querySelector('.custom-arrow.next');
    if ( !welcomeHasMultiple ) {
      prevArrow.style.display = 'none';
      nextArrow.style.display = 'none';
    } else {
      prevArrow.addEventListener('click', () => welcomeFlkty.previous());
      nextArrow.addEventListener('click', () => welcomeFlkty.next());
    }
  }

  // Reviews slider
  var reviews_slider = document.querySelector('.reviews-slider');
  if ( reviews_slider ) {
    var reviewCells = reviews_slider.children.length;
    var reviewsHasMultiple = reviewCells > 1;
    var reviewsFlkty = new Flickity(reviews_slider, {
      cellAlign: 'left',
      contain: true,
      wrapAround: reviewsHasMultiple,
      draggable: reviewsHasMultiple,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: reviewsHasMultiple ? 4000 : false,
      pauseAutoPlayOnHover: true,
      imagesLoaded: true
    });
  }

  // Image sliders
  var imageSliders = document.querySelectorAll('.image-slider');
  imageSliders.forEach(function(images_slider) {
    var imageCells = images_slider.children.length;
    var imagesHasMultiple = imageCells > 1;

    new Flickity(images_slider, {
      cellAlign: 'left',
      contain: true,
      wrapAround: imagesHasMultiple,
      draggable: imagesHasMultiple,
      prevNextButtons: false,
      pageDots: true,
      autoPlay: imagesHasMultiple ? 4000 : false,
      pauseAutoPlayOnHover: true,
      imagesLoaded: true
    });
  });

  // Select all links with hashes...
  document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"])')
    .forEach(link => {
      link.addEventListener('click', function (event) {

        // On-page links only
        const samePath = location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '');
        const sameHost = location.hostname === this.hostname;

        if (samePath && sameHost) {
          const hash = this.hash;
          let target = document.querySelector(hash);

          // Fallback: find element by name=
          if (!target) {
            const nameSelector = `[name="${hash.slice(1)}"]`;
            target = document.querySelector(nameSelector);
          }

          if (target) {
            event.preventDefault();

            // Smooth scroll
            target.scrollIntoView({ behavior: "smooth", block: "start" });

            // After scrolling, set focus
            setTimeout(() => {
              target.setAttribute("tabindex", "-1");
              target.focus({ preventScroll: true });
            }, 1000); // matches the old jQuery 1000ms animation
          }
        }
      });
    });

    // Match heights...
    const containers = document.querySelectorAll(".category-list__blocks");
    containers.forEach((container) => {     
      container.matchHeight({elements: '.block__icon', byRow: true, property: 'min-height' });
      container.matchHeight({elements: '.block__text', byRow: true, property: 'min-height' });
    });

    // Accordions...
    document.querySelectorAll('.accordion .accordion__heading').forEach(function (heading) {
      heading.addEventListener('click', function () {
        var accordion = heading.closest('.accordion');
        accordion.classList.toggle('open');
        var content = accordion.querySelector('.accordion__content');
        if ( getComputedStyle(content).maxHeight === '0px' ) {
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          content.style.maxHeight = '0';
        }
      });
    });

});